import Component from 'flarum/common/Component';
import extract from 'flarum/common/utils/extract';
import Icon from 'flarum/common/components/Icon';
export default class UsercardStat extends Component {
  view(vnode) {
    const attrs = Object.assign({}, this.attrs);
    const iconClass = extract(attrs, 'icon');
    const displayText = extract(attrs, 'displayText');
    return m("div", {
      className: "userStat"
    }, m(Icon, {
      name: iconClass
    }), displayText);
  }
}
flarum.reg.add('fof-usercard-stats', 'forum/components/UsercardStat', UsercardStat);